import { SUBMIT_TEST } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case SUBMIT_TEST:
            return {
                ...state,
                answerpayload: {},
            }
        default:
            return state
    }
}
